import * as Yup from 'yup';
import {
  GetSendOwnerInviteTemplateResponseTO,
  PropertyOwner,
} from 'models/Owner';
import { Namespace, TFunction } from 'react-i18next';

export const sendOwnerInviteSchema = ({
  t,
}: {
  t: TFunction<Namespace<'en'>>;
}) => {
  return Yup.object({
    content: Yup.string()
      .required()
      .test({
        name: 'content-dependency',
        message: t('form.validation.required'),
        test: () => {
          // Since the field actually uses the Lexical editor we can't just check for an empty string but rather we have
          // to check if the DOM node does not contain any text
          const contentElement = document.querySelector(
            '[data-testid="content"]',
          );

          return contentElement?.textContent?.trim().length !== 0;
        },
      }),
    content_htmlContent: Yup.string().required(),
    to: Yup.string().required(),
    subject: Yup.string().required(),
    sendCopyToAgency: Yup.boolean(),
  });
};

export type SendOwnerInviteSchemaFormValues = Yup.InferType<
  ReturnType<typeof sendOwnerInviteSchema>
>;

export function getFormDefaultValues({
  agencyName,
  owner,
  template,
}: {
  agencyName: string;
  owner: PropertyOwner;
  template?: GetSendOwnerInviteTemplateResponseTO | null;
}): SendOwnerInviteSchemaFormValues {
  return {
    content: template?.content ?? '',
    content_htmlContent: template?.content ?? '',
    sendCopyToAgency: true,
    subject: `You have a new message from ${agencyName}`,
    to: owner?.email ?? '',
  };
}
